export default __webpack_public_path__ + "static/media/timeline.3639cd98.svg";